import { render, staticRenderFns } from "./DoublePageLayout.vue?vue&type=template&id=43b77a66&scoped=true&"
import script from "./DoublePageLayout.vue?vue&type=script&lang=ts&"
export * from "./DoublePageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DoublePageLayout.vue?vue&type=style&index=0&id=43b77a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b77a66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VDialog,VExpandXTransition,VIcon,VRow,VSheet})
